<script>
export default {
  name: "ExcursionList",
  props: {
    excursionTxt: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      voices: [
        {
          id: "alena",
          title: "Женский (премиум)",
        },
        {
          id: "filipp",
          title: "Мужской (премиум)",
        },
        {
          id: "oksana",
          title: "Оксана",
        },
        {
          id: "jane",
          title: "Джейн",
        },
        {
          id: "omazh",
          title: "Омаж",
        },
        {
          id: "zahar",
          title: "Захар",
        },
        {
          id: "ermil",
          title: "Эрмил",
        },
      ],
      voice: {
        id: "alena",
        title: "Женский (премиум)",
      },
      message: "",
    }
  },
  mounted() {
    this.message = this.excursionTxt
  },
  watch: {
    message(newValue, oldValue) {
      if (newValue.length > 5000) {
        // this.message = oldValue
      }
    },
  },
  methods: {
    makeToast(body = "Ничего не произошло", variant = "warning", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    yaSpeechKit(guid) {
      axios
        .post(`/webapi/excursion/synthesize/${guid}`, {
          voice: this.voice.id,
          message: this.message,
        })
        .then(({data}) => {
          if (data.status) {
            window.location.reload()
          } else {
            this.makeToast("Ошибка, попробуйте еще раз", "danger", "Ошибка")
          }
        })
        .catch(() => {
          this.makeToast("Ошибка, попробуйте еще раз", "danger", "Ошибка")
        })
    },
    yaSpeechKitDel(guid) {
      axios.delete(`/webapi/excursion/synthesize/${guid}`).then(({data}) => {
        window.location.reload()
      })
    },
    fileDelete(url) {
      window.location = url
    },
    inputFileChange(ref) {
      let files = this.$refs["file_input_" + ref].files
      if (files.length > 0) {
        this.$refs["file_form_" + ref].submit()
      }
    },
    fileUpload(ref) {
      this.$refs["file_input_" + ref].click()
    },
  },
}
</script>
